import React from 'react';
import { CheckCircle2 } from 'lucide-react';
export function WhyChooseSection() {
  const reasons = ['No hauling chemicals into tight spaces', 'No pouring into backpacks or small tanks', 'No battery failures or downtime', 'Faster setup and cleanup', 'Cleaner, more controlled spraying'];
  return <section className="py-16 bg-white" data-id="element-828">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-829">
        <h2 className="text-3xl font-bold text-brand-dark mb-8" data-id="element-830">
          Why Contractors Choose ForceX
        </h2>
        <div className="space-y-4" data-id="element-831">
          {reasons.map((reason, index) => <div key={index} className="flex items-start p-4 bg-brand-light rounded-lg border border-gray-200" data-id="element-832">
              <CheckCircle2 className="h-6 w-6 text-brand-yellow mr-4 mt-0.5 flex-shrink-0" data-id="element-833" />
              <span className="text-gray-700 text-lg" data-id="element-834">{reason}</span>
            </div>)}
        </div>
      </div>
    </section>;
}